import { useState } from "react";
import { stringifyKey } from "../../decorators/StoreIdHelper";
import { AcceleratorDocModelStore } from "../../stores/impl/AcceleratorDocModelStore";
import { AcceleratorDocStoreKey } from "../../models/AcceleratorDoc";

export { DocModelAssociationDebugger };

type Props = {
  batchClassId: string;
  intervalMs: number;
  currentBatchUuid?: string;
};

type Association = {
  type: "UNKNOWN" | "MAP" | "REVMAP";
  model: string;
  doc: string;
};

const DocModelAssociationDebugger = (props: Props) => {
  const [filterBatch, setFilterBatch] = useState(true);
  const [associations, setAssociations] = useState<
    Array<Association> | undefined
  >(undefined);
  // const [lastUpdated] = useTimer(async (filter: boolean, currentBatchUuid?: string) => {
  const dumpAssociations = () => {
    console.log("FILTERING BATCH?:" + filterBatch);
    //@ts-expect-error
    const revMap = AcceleratorDocModelStore.revMap;
    //@ts-expect-error
    const unknownMap = AcceleratorDocModelStore.unknownMap;
    //@ts-expect-error
    const map = AcceleratorDocModelStore.map;

    const assocs: Association[] = [];
    map.forEach((modelKey, docKeyStr) => {
      const docKey = JSON.parse(docKeyStr) as AcceleratorDocStoreKey;
      if (filterBatch && docKey.batchInstanceUuid !== props.currentBatchUuid) {
        return;
      }
      assocs.push({
        type: "MAP",
        model: stringifyKey(modelKey),
        doc: docKeyStr,
      });
    });

    console.table(assocs);
    return assocs;
  };
  //     (assocs) => setAssociations(assocs),
  //     filterBatch, props.currentBatchUuid);

  return (
    <div>
      <button onClick={() => dumpAssociations()}>Dump Associations</button>
      <label>Filter By Current Batch ({props.currentBatchUuid})</label>
      <input
        name={"debugFilterBatchUuid"}
        type={"checkbox"}
        checked={filterBatch}
        onChange={() => setFilterBatch(!filterBatch)}
      />
    </div>
  );
};
